import { useEffect, useState } from "react";
import { Navigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import { useHasWayaOfficialAccess } from "@/hooks/use-waya-official-access";
import { clearAccessToken } from "@/redux/actions/auth-actions";
import {
  clearActiveSession,
  clearWayaOfficialUnlocked,
  hasWayaOfficialUnlocked,
} from "@/utils/auth-session";
import WayaOfficialOtpGate from "@/pages/waya-official/waya-official-otp-gate";

// Gate 1 — role. Anyone without ROLE_ADMIN_OWNER hitting this URL directly
// is treated as a suspicious attempt, not a normal permissions miss: force
// a full logout (clear token + session markers) and bounce to login,
// rather than quietly redirecting to the dashboard like the ledger guard.
//
// Gate 2 — OTP. An Owner who hasn't verified this session sees the OTP
// challenge in place of the page. The unlock persists in sessionStorage
// (cleared on browser close or logout) so a refresh doesn't re-demand a code.

const WayaOfficialRouteGuard = ({ children }) => {
  const hasAccess = useHasWayaOfficialAccess();
  const dispatch = useDispatch();
  const [unlocked, setUnlocked] = useState(hasWayaOfficialUnlocked());

  useEffect(() => {
    if (!hasAccess) {
      dispatch(clearAccessToken());
      clearActiveSession();
      clearWayaOfficialUnlocked();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [hasAccess]);

  if (!hasAccess) {
    return <Navigate to="/session/login" replace />;
  }

  if (!unlocked) {
    return <WayaOfficialOtpGate onUnlocked={() => setUnlocked(true)} />;
  }

  return children;
};

export default WayaOfficialRouteGuard;